import { jsxs as C, jsx as r } from "react/jsx-runtime";
import { useRef as h, useEffect as P } from "react";
import { FloatingElementContainer as z, ChildClone as E, ContentWrapper as R, FloatingElement as $ } from "./style.js";
function I({
  floatingElement: d,
  children: u,
  className: y,
  openTo: n,
  isVisible: m,
  role: g
}) {
  const o = h(null), e = h(null);
  return P(() => {
    const x = setInterval(() => {
      var i, l, a, p, s, c, f;
      const t = (i = o.current) == null ? void 0 : i.getBoundingClientRect(), v = (l = o.current) == null ? void 0 : l.offsetTop;
      (a = e.current) == null || a.style.setProperty("--opacity", "1"), (p = e.current) == null || p.style.setProperty("--width", `${t == null ? void 0 : t.width}px`), (s = e.current) == null || s.style.setProperty("--height", `${t == null ? void 0 : t.height}px`), (c = e.current) == null || c.style.setProperty("--top", `${v}px`), (f = e.current) == null || f.style.setProperty("--left", `${t == null ? void 0 : t.left}px`);
    }, 500);
    return () => clearInterval(x);
  }, []), /* @__PURE__ */ C(z, { className: y, children: [
    /* @__PURE__ */ r("div", { ref: o, children: u }),
    /* @__PURE__ */ r(E, { ref: e, children: /* @__PURE__ */ r(R, { "data-horizontal-position": n.horizontal, children: /* @__PURE__ */ r(
      $,
      {
        "aria-hidden": !m,
        "data-horizontal-position": n.horizontal,
        "data-vertical-position": n.vertical,
        role: g,
        children: d
      }
    ) }) })
  ] });
}
export {
  I as FloatingElementWrapper
};
